// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module__footer__UZpYC","footerContent":"Footer-module__footerContent__m9xkS","hr":"Footer-module__hr__qCJVS"};